/**
 * Represents the approval user's role. If the use is owner or approver, he/she could view some extra features.
 */ export var ApprovalUserRole;
(function(ApprovalUserRole) {
    /** The current user is neither owner of this approval nor one of the required approvers. */ ApprovalUserRole["NotSpecified"] = "NotSpecified";
    /** The current user is the owner of this approval. */ ApprovalUserRole["Owner"] = "Owner";
    /** The current user is one of the required approvers of this approval. */ ApprovalUserRole["Approver"] = "Approver";
    /** Other cases. */ ApprovalUserRole["DelegatedAccess"] = "DelegatedAccess";
})(ApprovalUserRole || (ApprovalUserRole = {}));
